var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.5V6H42V19.5ZM6 25.5V6H22.5V25.5ZM25.5 42V22.5H42V42ZM6 42V28.5H22.5V42ZM9 22.5H19.5V9H9ZM28.5 39H39V25.5H28.5ZM28.5 16.5H39V9H28.5ZM9 39H19.5V31.5H9ZM19.5 22.5ZM28.5 16.5ZM28.5 25.5ZM19.5 31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.68c8616e1cbfea54e494ff888074e5ac.svg";
export { ForwardRef as ReactComponent };